import { CommonHeader } from "../../components/commons";
import { connect } from "react-redux";
import { ClientDashboardCard } from "../../components/ClientDashboard";
import { RootState } from "../../redux/rootReducers";
import { useEffect } from "react";
type AppProps = {
  history?: any;
  sideMenus?: any[];
};
const HRMS = ({ history, sideMenus }: AppProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderModules = () => {
    let HRMS: any =
      sideMenus &&
      sideMenus?.length > 0 &&
      sideMenus?.filter((menu) => menu?.menu_name === "HRMS");

    let finalList = HRMS[0]?.sub_menu?.map((list: any) => {
      return (
        <div className={`col-md-4 mb-4 ${list.extraClasses}`}>
          <ClientDashboardCard
            isNew={list.is_new}
            key={list.menu_name}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.comingSoon}
          />
        </div>
      );
    });

    return finalList;
  };
  const handleRedirection = (moduleName: string | undefined) => {
    switch (moduleName) {
      case "redirectToHRDashboard":
        return history.push(`/hrms/hr-dashboard`);
      case "redirectRecruitmentModule":
        return history.push(`/hrms/recruitment-module`);
      case "redirectToAllUsersCheckInReports":
        return history.push(`/hrms/check-in-reports`);
      case "redirectToAllUsersPerformanceEvaluationReport":
        return history.push(`/hrms/performance-evaluation-report`);
      case "redirectToAllUsersLeaveHistoryReport":
        return history.push(`/hrms/leave-history-report`);
      case "redirectToAllUsersRatingReport":
        return history.push(`/hrms/rating-report`);
      default:
        return null;
    }
  };
  return (
    <div>
      <CommonHeader title="HRMS" />
      <div className="row mt-3">{renderModules()}</div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  sideMenus: state.auth.sideMenus,
});
export default connect(mapStateToProps)(HRMS);
